export type IStrikeZoneDefinition = IStrikeZone & {
  name: string;
  customDefinition?: IStrikeZone | null;
};

export enum StrikeZoneLocation {
  Front = 'Front',
  Middle = 'Middle',
  Back = 'Back',
}

export interface IStrikeZoneLocation {
  locationType: StrikeZoneLocation;
  offsetY: number;
  bottomExtension?: number;
}

interface IStrikeZone {
  activeStrikeZone?: StrikeZoneDefinitionEnum;
  staticStrikeZoneBottom?: number;
  staticStrikeZoneTop?: number;
  staticStrikeZoneWidth?: number;
  heightStrikeZoneBottomPercentage?: number;
  heightStrikeZoneTopPercentage?: number;
  heightStrikeZoneWidth?: number;
  topBottomStrikeZoneWidth?: number;
  ballDiameter: number | null;
  locations?: IStrikeZoneLocation[];
}

export enum StrikeZoneDefinitionEnum {
  Static = 'Static',
  HeightBased = 'HeightBased',
  TopAndBottomBased = 'TopAndBottomBased',
}

export enum LeagueStrikeZoneEnum {
  StaticStrikeZone = 'staticStrikeZone',
  HeightBasedStrikeZone = 'heightBasedStrikeZone',
  TopAndBottomStrikeZone = 'topAndBottomStrikeZone',
}

export const StrikeZoneDict: { [key: string]: string } = {
  Static: 'Static SZ',
  HeightBased: 'Height based SZ',
  TopAndBottomBased: 'Top and bottom SZ',
};

export type OverrideStrikeZoneProperty = Pick<
  IStrikeZoneDefinition,
  | 'staticStrikeZoneBottom'
  | 'staticStrikeZoneTop'
  | 'staticStrikeZoneWidth'
  | 'heightStrikeZoneBottomPercentage'
  | 'heightStrikeZoneTopPercentage'
  | 'heightStrikeZoneWidth'
  | 'topBottomStrikeZoneWidth'
  | 'ballDiameter'
  | 'activeStrikeZone'
>;
